(() => {
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-campaign-slide]')];
    if (slides.length < 2) return;
    const dots = [...root.querySelectorAll('[data-campaign-dot]')];
    const toggle = root.querySelector('[data-campaign-toggle]');
    const counter = root.querySelector('[data-campaign-counter]');
    const status = root.querySelector('[data-campaign-status]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const delay = Math.min(5000, Math.max(3000, Number(root.dataset.delay) || 4000));
    let index = 0, timer = null, hovered = false, focused = false;
    let paused = reduced.matches || root.dataset.autoplay === 'false';
    let touch = null, userPlay = false;
    function stop() { if (timer !== null) clearInterval(timer); timer = null; }
    function sync() {
      stop();
      toggle.textContent = paused ? 'Play' : 'Pause';
      toggle.setAttribute('aria-label', paused ? 'Start automatic photo rotation' : 'Pause automatic photo rotation');
      if (!paused && (userPlay || (!hovered && !focused)) && !document.hidden && root.isConnected) timer = setInterval(() => show(index + 1), delay);
    }
    function show(next, manual = false) {
      let target = (next + slides.length) % slides.length;
      if (!slides[target].complete) { if (manual) slides[target].addEventListener('load', () => show(target, true), {once:true}); return; }
      if (slides[target].complete && slides[target].naturalWidth === 0) return;
      index = target;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      if (manual) { status.textContent = 'Photo ' + (index + 1) + ' of ' + slides.length + ': ' + slides[index].alt; sync(); }
    }
    root.querySelector('[data-campaign-prev]').addEventListener('click', () => show(index - 1, true));
    root.querySelector('[data-campaign-next]').addEventListener('click', () => show(index + 1, true));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i, true)));
    toggle.addEventListener('click', () => { paused = !paused; userPlay = !paused; sync(); });
    root.addEventListener('mouseenter', () => { hovered = true; userPlay = false; sync(); });
    root.addEventListener('mouseleave', () => { hovered = false; sync(); });
    root.addEventListener('focusin', () => { focused = true; userPlay = false; sync(); });
    root.addEventListener('focusout', () => { setTimeout(() => { focused = root.contains(document.activeElement); sync(); }, 0); });
    root.addEventListener('touchstart', event => { if (event.target.closest('a,button')) return; const point = event.touches[0]; touch = {x:point.clientX,y:point.clientY}; }, {passive:true});
    root.addEventListener('touchend', event => { if (!touch) return; const point = event.changedTouches[0], dx = point.clientX - touch.x, dy = point.clientY - touch.y; touch = null; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1), true); }, {passive:true});
    const visibility = () => sync();
    const preference = () => { if (reduced.matches) paused = true; sync(); };
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', preference);
    instances.set(root, () => { stop(); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', preference); });
    show(0); sync();
  }
  const load = scope => scope.querySelectorAll('[data-campaign-carousel]').forEach(init);
  load(document);
  document.addEventListener('shopify:section:load', event => load(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of instances) { if (event.target.contains(root)) { dispose(); instances.delete(root); } } });
})();
